module.exports = __webpack_public_path__ + "static/graduates-5d84f388fbfac68995538de4bd9d9e9d.svg";